





















































import {Vue, Component} from 'vue-property-decorator';
import {Action, namespace} from 'vuex-class';
import {IUserData} from "@/models/ApiModels";
import {EClickCollectType} from "@/constants/orders";
import {CLICK_AND_COLLECT_CORTE_INGLES_ROUTES} from "@/constants/routes";
import {IHub} from "@/models/StoreModels";
import HubSelector from "@/views/components/FormInputs/HubSelector.vue";
import TextAreaInput from "@/views/components/FormInputs/TextAreaInput.vue";
import {errorHandler} from "@/services/services";
import ShipmentForm from '@/views/components/ShipmentForm.vue';

const userDataModule = namespace("userData");
const shipmentModule = namespace("shipment");

const CORTE_INGLES_ADDRESS = 'Centre Comercial Girocentre, Carrer Barcelona, 106, 110, 17003 Girona';

@Component({
  name: 'ClickAnCollectCISummary',
  components: {
    HubSelector,
    ShipmentForm,
    TextAreaInput,
  },
})
export default class ClickAnCollectCISummary extends Vue {
  @Action('sendCCCorteInglesToApi')
  private sendCCCorteInglesEmail!: () => Promise<any>;

  @shipmentModule.Getter('getCCType')
  private type!: EClickCollectType;

  @userDataModule.Getter('getProfile')
  private profile!: IUserData;

  @shipmentModule.Getter('getCCPhoneNumber')
  private ccPhoneNumber!: string;

  @shipmentModule.Getter('getCCName')
  private ccName!: string;

  @shipmentModule.Getter('getCCShopAddress')
  private ccShopAddress!: string;

  @shipmentModule.Getter('getCCSComments')
  private ccComments!: string;

  @shipmentModule.Getter('getCCHub')
  private ccHub!: IHub;

  @shipmentModule.Action('setCCPhoneNumber')
  private setCCPhoneNumber!: (el: string) => void;

  @shipmentModule.Action('setCCName')
  private setCCName!: (el: string) => void;

  @shipmentModule.Action('setCCShopAddress')
  private setCCShopAddress!: (el: string) => void;

  @shipmentModule.Action('setCCComments')
  private setCCComments!: (el: string) => void;

  @shipmentModule.Action('setCCHub')
  private setCCHub!: (el: IHub) => void;

  private email: string = '';
  private name: string = '';
  private phoneNumber: string = '';
  private shopAddress: string = CORTE_INGLES_ADDRESS;

  private created() {
    this.email = this.profile.email;
    this.name = this.profile.first_name;
    this.phoneNumber = this.profile.phone_number; // our phone number is always the same
  }

  private next() {
    this.startLoading();
    this.sendCCCorteInglesEmail()
        .then(this.goToFinish)
        // .then(() => this.$uiBus.emit("apiStatus:error")) // todo: ???
        .catch(this.showErrors)
        .finally(this.finishLoading);
  }

  private startLoading() {
    this.$uiBus.emit("apiStatus:loading");
  }

  private finishLoading() {
    this.$uiBus.emit("apiStatus:finish");
  }

  private showErrors(err: any) {
    this.$uiBus.emit("apiStatus:error");
    const errors = errorHandler.handleErrorsResponse(err, 'clickAndCollect.errors');
    Vue.set(this, 'errors', errors);
  }

  private goToFinish() {
    this.$router.push({ name: CLICK_AND_COLLECT_CORTE_INGLES_ROUTES.FINISH });
  }

}
